import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Page, SectionHeading, BackLink, Tag } from "./ui";
import { projects } from "../data/portfolio";

export default function Projects() {
  return (
    <Page className="gap-10">
      <div className="space-y-6">
        <BackLink />
        <div className="space-y-2">
          <SectionHeading as="h1" className="text-2xl sm:text-3xl">
            Projects
          </SectionHeading>
          <p className="text-sm text-neutral-500">Powered by my curiosity.</p>
        </div>
      </div>

      <ul className="grid gap-4">
        {projects.map((project) => (
          <li key={project.slug}>
            <Link
              to={`/projects/${project.slug}`}
              className="group block border border-black/10 bg-black/[0.02] p-5 transition-colors duration-200 hover:border-black/20 hover:bg-black/[0.04] focus:outline-none focus-visible:ring-2 focus-visible:ring-black/30 dark:border-white/10 dark:bg-white/[0.02] dark:hover:border-white/20 dark:hover:bg-white/[0.04] dark:focus-visible:ring-white/40 sm:p-6"
            >
              <div className="flex items-start justify-between gap-4">
                <h2 className="text-lg font-semibold text-neutral-900 dark:text-white">
                  {project.name}
                </h2>
                <ArrowUpRight
                  size={18}
                  aria-hidden="true"
                  className="mt-1 shrink-0 text-neutral-500 transition-all duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-neutral-900 dark:group-hover:text-white"
                />
              </div>
              <p className="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">
                {project.summary}
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {project.tech.map((tech) => (
                  <Tag key={tech}>{tech}</Tag>
                ))}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
}
